module.exports = __webpack_public_path__ + "img/dam-profile-image.576708b2.svg";